import * as React from 'react'
import { Link } from 'gatsby'
import DropdownMenuLink from '../HomeMenu/DropdownMenuLink'
import DropdownMenuContainer from './DropdownMenuContainer'

const JewelryDropDownMenu = ({ dropDown, onMenuLinkClick, setDropDown }) => {
  return (
    <DropdownMenuContainer selectedDropDown={dropDown} dropDownIndex={2} setDropDown={setDropDown}>
      <div className="w-[calc(100vw-3em)] md:w-[calc(100vw-11.25rem)] sticky font-bold text-red-600 top-0 bg-white justify-between items-center mb-2 left-0 h-14 flex flex-row border-b lg:hidden">
        FINE JEWELRY
        <Link
          to="/jewelry/"
          onClick={onMenuLinkClick}
          className="text-sm py-4 px-5 text-gray-600 font-normal underline underline-offset-2 decoration-slate-300"
        >
          See All
          <span className="sr-only">Fine Jewelry</span>
        </Link>
      </div>

      {/* Block 1 */}
      <div>
        {/* <Link
          to={'/jewelry/designer-jewelry/'}
          onClick={onMenuLinkClick}
          className=" text-gray-700 lg:border-transparent py-3 lg:py-0 lg:text-sm lg:hover:font-bold lg:hover:text-red-700 block w-full font-bold"
        >
          DESIGNER JEWELRY delete
        </Link> */}
        <div className="w-[calc(100vw-3em)] md:w-[calc(100vw-11.25rem)] font-bold text-gray-600 items-center h-14 lg:h-auto flex flex-row justify-between">
          DESIGNER JEWELRY
          <Link
            to={'/jewelry/designer-jewelry/'}
            onClick={onMenuLinkClick}
            className="lg:hidden text-sm px-5 text-gray-600 font-normal underline underline-offset-2 decoration-slate-300"
          >
            See All
            <span className="sr-only">Designer Jewelry</span>
          </Link>
        </div>
        <div className=" grid grid-flow-row">
          <DropdownMenuLink
            to="/jewelry/designer-jewelry/bvlgari-jewelry/"
            onClick={onMenuLinkClick}
          >
            Bvlgari Jewelry
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/designer-jewelry/cartier-jewelry/"
            onClick={onMenuLinkClick}
          >
            Cartier Jewelry
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/designer-jewelry/chopard-jewelry/"
            onClick={onMenuLinkClick}
          >
            Chopard Jewelry
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/designer-jewelry/chimento-jewelry/"
            onClick={onMenuLinkClick}
          >
            Chimento Jewelry
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/designer-jewelry/david-yurman-jewelry/"
            onClick={onMenuLinkClick}
          >
            David Yurman Jewelry
          </DropdownMenuLink>
          <DropdownMenuLink to="/jewelry/designer-jewelry/john-hardy/" onClick={onMenuLinkClick}>
            John Hardy Jewelry
          </DropdownMenuLink>
          <DropdownMenuLink to="/jewelry/designer-jewelry/konstantino/" onClick={onMenuLinkClick}>
            Konstantino
          </DropdownMenuLink>
          <DropdownMenuLink to="/jewelry/designer-jewelry/roberto-coin/" onClick={onMenuLinkClick}>
            Roberto Coin Jewelry
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/designer-jewelry/sonia-b-jewelry/"
            onClick={onMenuLinkClick}
          >
            Sonia B Jewelry
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/designer-jewelry/tiffany-and-co-jewelry/"
            onClick={onMenuLinkClick}
          >
            Tiffany & Co. Jewelry
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/designer-jewelry/van-cleef-and-arpels/"
            onClick={onMenuLinkClick}
          >
            Van Cleef & Arpels Jewelry
          </DropdownMenuLink>
        </div>
        <DropdownMenuLink to="/jewelry/designer-jewelry/" onClick={onMenuLinkClick}>
          <b className="hidden lg:block">VIEW ALL DESIGNER JEWELRY</b>
        </DropdownMenuLink>
      </div>

      {/* Block 2 */}
      <div className={' w-full lg:min-h-max '}>
        <div className="lg:text-sm text-gray-700 lg:hover:font-bold lg:hover:text-red-700 w-full font-bold">
          SHOP BY CATEGORY
        </div>

        <div className=" grid grid-flow-row lg:px-0">
          <DropdownMenuLink to="/jewelry/luxury-estate-rings/" onClick={onMenuLinkClick}>
            Rings and Bands
          </DropdownMenuLink>
          <DropdownMenuLink to="/jewelry/earrings/" onClick={onMenuLinkClick}>
            Earrings
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/estate-jewelry-and-vintage-jewelry/bracelets-and-bangles/"
            onClick={onMenuLinkClick}
          >
            Cuffs & Bracelets
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/estate-jewelry-and-vintage-jewelry/necklaces/"
            onClick={onMenuLinkClick}
          >
            Necklaces
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/estate-jewelry-and-vintage-jewelry/pendants/"
            onClick={onMenuLinkClick}
          >
            Pendants
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/estate-jewelry-and-vintage-jewelry/cufflinks/"
            onClick={onMenuLinkClick}
          >
            Cufflinks
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/estate-jewelry-and-vintage-jewelry/jewelry-sets/"
            onClick={onMenuLinkClick}
          >
            Jewelry Sets
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/estate-jewelry-and-vintage-jewelry/mens-jewelry/"
            onClick={onMenuLinkClick}
          >
            Mens Jewelry
          </DropdownMenuLink>
          <DropdownMenuLink to="/accessories/pens/" onClick={onMenuLinkClick}>
            Pens
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/estate-jewelry-and-vintage-jewelry/pins-and-brooches/"
            onClick={onMenuLinkClick}
          >
            Pins & Brooches
          </DropdownMenuLink>
        </div>
      </div>

      {/* Block 3 */}
      <div className="flex flex-col">
        <div className="w-[calc(100vw-3em)] md:w-[calc(100vw-11.25rem)] font-bold text-gray-600 items-center h-14 lg:h-auto flex flex-row justify-between">
          GIA CERTIFIED DIAMONDS
          <Link
            to="/gia-diamonds/"
            onClick={onMenuLinkClick}
            className="lg:hidden text-sm py-4 px-5 text-gray-600 font-normal underline underline-offset-2 decoration-slate-300"
          >
            See All
            <span className="sr-only">GIA Certified Diamonds</span>
          </Link>
        </div>

        <DropdownMenuLink to="/gia-diamonds/engagement-rings/" onClick={onMenuLinkClick}>
          GIA Certified Rings
        </DropdownMenuLink>
        <DropdownMenuLink to="/gia-diamonds/gia-diamond-studs/" onClick={onMenuLinkClick}>
          GIA Certified Earring Studs
        </DropdownMenuLink>
        <DropdownMenuLink to="/gia-diamonds/gia-certified-jewelry/" onClick={onMenuLinkClick}>
          Other GIA Certified Jewelry
        </DropdownMenuLink>

        <Link
          className="hidden lg:block py-3 text-gray-600 lg:border-transparent lg:py-0 lg:text-sm lg:text-gray-700 lg:hover:font-bold lg:hover:text-red-700 mt-3 "
          to="/gia-diamonds/"
          onClick={onMenuLinkClick}
        >
          ALL GIA CERTIFIED DIAMOND JEWELRY
        </Link>

        {/* SHOP BY STONE */}
        <div className="mt-3 ">
          <div className=" py-3 text-gray-600 lg:border-transparent lg:py-0 lg:text-sm lg:text-gray-700 lg:hover:font-bold lg:hover:text-red-700 w-full font-bold">
            SHOP BY STONE
          </div>
          <div className=" grid grid-flow-row">
            <DropdownMenuLink
              to="/jewelry/estate-jewelry-and-vintage-jewelry/diamond-jewelry/"
              onClick={onMenuLinkClick}
            >
              Diamond Jewelry
            </DropdownMenuLink>
            <DropdownMenuLink
              to="/jewelry/estate-jewelry-and-vintage-jewelry/emerald-jewelry/"
              onClick={onMenuLinkClick}
            >
              Emerald Jewelry
            </DropdownMenuLink>
            <DropdownMenuLink
              to="/jewelry/estate-jewelry-and-vintage-jewelry/sapphire-jewelry/"
              onClick={onMenuLinkClick}
            >
              Sapphire Jewelry
            </DropdownMenuLink>
            <DropdownMenuLink
              to="/jewelry/estate-jewelry-and-vintage-jewelry/ruby-jewelry/"
              onClick={onMenuLinkClick}
            >
              Ruby Jewelry
            </DropdownMenuLink>
            <DropdownMenuLink
              to="/jewelry/estate-jewelry-and-vintage-jewelry/pearl-jewelry/"
              onClick={onMenuLinkClick}
            >
              Pearl Jewelry
            </DropdownMenuLink>
          </div>
        </div>
      </div>

      {/* Block 4 */}
      <div>
        <div className="hidden lg:grid grid-flow-row">
          <div className=" py-3 text-gray-600 lg:py-0 lg:text-sm lg:text-gray-700 lg:hover:font-bold w-full font-bold">
            SHOP BY PRICE
          </div>
          <DropdownMenuLink
            to="/jewelry/?2499#price_filter=%240%20-%20%242%2C499"
            onClick={onMenuLinkClick}
          >
            $0.00 - $2,499
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/?4999#price_filter=%242%2C500%20-%20%244%2C999"
            onClick={onMenuLinkClick}
          >
            $2,500 - $4,999
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/?9999#price_filter=%245%2C000%20-%20%249%2C999"
            onClick={onMenuLinkClick}
          >
            $5,000 - $9,999
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/?19999#price_filter=%2410%2C000%20-%20%2419%2C999"
            onClick={onMenuLinkClick}
          >
            $10,000 - $19,999
          </DropdownMenuLink>
          <DropdownMenuLink
            to="/jewelry/?99999#price_filter=%2420%2C000%2B"
            onClick={onMenuLinkClick}
          >
            $20,000 +
          </DropdownMenuLink>
        </div>

        <div className="py-3 bg-gray-100 lg:bg-transparent">
          <div className=" py-3 text-gray-600 lg:border-transparent lg:py-0 lg:text-sm lg:text-gray-700 lg:hover:font-bold lg:hover:text-red-700 w-full font-bold">
            ADDITIONAL <span className="sr-only">JEWELRY</span> LINKS
          </div>
          <div className=" grid grid-flow-row">
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              className={
                ' py-3 text-gray-600 lg:border-transparent lg:py-0 lg:text-sm lg:text-gray-700 lg:hover:font-bold lg:hover:text-red-700'
              }
              href="https://sellusyourjewelry.com/?utm_source=referral&utm_medium=grayandsons"
              target={'_blank'}
              rel={'noopener'}
            >
              Sell Your Jewelry
            </a>
            <DropdownMenuLink to="/jewelry-repair/" onClick={onMenuLinkClick}>
              Jewelry Repair
            </DropdownMenuLink>
            <DropdownMenuLink to="/jewelry-repair/" onClick={onMenuLinkClick}>
              Jewelry Related Blogs
            </DropdownMenuLink>
          </div>
        </div>
      </div>
    </DropdownMenuContainer>
  )
}

export default JewelryDropDownMenu
